import React, { useState, useEffect } from 'react';
import moment from 'moment';
import { DateCtn, SvgCtn } from './index.style';

import ICONS from '../../assets/icons';
import COLORS from '../../assets/styles/config/colors';

interface SlaProps {
  slaStatus: 'upcomingToday' | 'missedDeadline' | 'doneOnTime' | 'urgentlyUpcoming' | 'upcoming';
  date: string;
}

const dateFormats = {
  sameDay: '[Today], h:mma',
  nextDay: '[Tomorrow], h:mma',
  nextWeek: 'ddd, Do MMM, h:mma',
  lastDay: '[Yesterday], h:mma',
  lastWeek: 'ddd, Do MMM, h:mma',
  sameElse: 'ddd, Do MMM, h:mma',
};

const DateLabel: React.FC<SlaProps> = ({ slaStatus, date, page }): React.ReactElement | null => {
  // PORTAL-175. `date` reaches here as either a raw Pronto field or, on the reactive call sites,
  // SLAOnsiteEstimated+' '+SLAOnsiteEstimatedTime - string concatenation, so a missing field
  // arrives as the literal text "undefined 14:30", not undefined itself. moment() can't tell that
  // apart from a real date without being asked, and moment(undefined) is a separate trap: it
  // silently returns the CURRENT moment rather than an invalid one. So blank/missing is checked
  // explicitly before ever calling moment(), and moment's own isValid() catches everything else
  // unparsable (null, empty string, "undefined ...", a malformed value).
  const getDate = () => {
    if(!date || !moment(date).isValid()) return null;
    if(page === 'planned') {
      return moment(date).format('MMMM')
    } else {
      return moment(date).calendar('',dateFormats)
    }
  };

  const [formattedDataTime, setDateTime] = useState(() => getDate());
  const [slaBold, setSlaBold] = useState(slaStatus === 'upcoming'? false: true);

  const slaColor = COLORS.slaPrimary[slaStatus];

  useEffect(() => {
    setDateTime(getDate());
  },[date]);

  // No valid date - hide the whole label (icon included), not just the text next to a dangling
  // clock icon.
  if(!formattedDataTime) return null;

  return (
    <DateCtn slaColor={slaColor} slaBold={slaBold}>
      <SvgCtn>
        <ICONS.clock />
      </SvgCtn>
      <span>{formattedDataTime}</span>
    </DateCtn>
  );
};

export default DateLabel;
